import React from 'react'
import HeaderTitle from '../Header/HeaderTitle'
import { connect } from 'react-redux'
import {
  postPins,
  getPinsWithHooks,
  createPinGenerationHook,
  deletePinGenerationHook,
  revokePin,
  resetRevokeMessage,
} from '../../store/PinGeneration/actionCreator'
import CreationSuccessModal from './CreationSuccessModal'
import RevokePinDialog from './RevokePinDialog'
import apiConfig from '../../config/apiConfig'
import {
  FormGroup,
  FormControlLabel,
  Grid,
  Tooltip,
  Switch,
  IconButton,
} from '@mui/material'
import PinHelpDialog from './PinHelpDialog'
import MrtReusableTable from '../Utils/MrtReusableTable'
import { ziptieColors } from '../../config/themeConfig'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import RemoveIcon from '@mui/icons-material/RemoveCircleOutline'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'

export class PinGeneration extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      smartsheetId: '',
      result: '',
      pinsList: [],
      dialogOpen: false,
      revokeDialogOpen: false,
      revokeMessageOpen: false,
      pinHelpOpen: false,
      revokePinHelpOpen: false,
      pinsMessage: '',
      revokeMessage: '',
      newWebhookData: {},
      rowLoading: [],
    }
    this.baseState = { ...this.state }
    this.dialogBox = React.createRef()
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.revokePinDialogData = this.revokePinDialogData.bind(this)
    this.handleRevokeOpen = this.handleRevokeOpen.bind(this)
    this.handleRevokeClose = this.handleRevokeClose.bind(this)
    this.handleMessageOpen = this.handleMessageOpen.bind(this)
    this.handleMessageClose = this.handleMessageClose.bind(this)
    this.handlePinHelpOpen = this.handlePinHelpOpen.bind(this)
    this.handlePinHelpClose = this.handlePinHelpClose.bind(this)
    this.handleRevokePinHelpOpen = this.handleRevokePinHelpOpen.bind(this)
    this.handleRevokePinHelpClose = this.handleRevokePinHelpClose.bind(this)
    this.toggleWebhook = this.toggleWebhook.bind(this)
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
      lanId: undefined,
    },
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Pin Generation',
        'Pin Generation Page Load',
        userInfo,
      )
    }
    this.setState({ loading: true })
    await this.props.getPinsWithHooks()
    this.setState({ loading: false })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.pinsMessage !== '' && nextProps.pinsMessage !== undefined) {
      this.setState({
        pinsMessage: nextProps.pinsMessage,
        pinsList: JSON.parse(JSON.stringify(nextProps.pinsList)),
      })
    } else {
      this.setState({
        pinsList: JSON.parse(JSON.stringify(nextProps.pinsList)),
        rowLoading: [],
      })
    }
    this.setState({
      revokeMessage: nextProps.revokeMessage,
    })
  }

  handleRevokeOpen() {
    this.setState({ revokeDialogOpen: true })
  }

  handleRevokeClose() {
    this.setState({ revokeDialogOpen: false })
    this.dialogBox.current.resetForm()
  }

  handlePinHelpOpen() {
    this.setState({ pinHelpOpen: true })
  }

  handlePinHelpClose() {
    this.setState({ pinHelpOpen: false })
  }

  handleRevokePinHelpOpen() {
    this.setState({ revokePinHelpOpen: true })
  }

  handleRevokePinHelpClose() {
    this.setState({ revokePinHelpOpen: false })
  }

  handleOpen() {
    this.setState({ dialogOpen: true })
  }

  handleClose() {
    if (
      this.state.pinsMessage.includes('PIN request submitted') ||
      this.state.pinsMessage.includes('Missing data for')
    ) {
      this.props.createPinGenerationHook(this.state.newWebhookData)
    } else {
      this.setState({ rowLoading: [] })
    }
    this.setState({
      dialogOpen: false,
    })
  }
  handleMessageOpen() {
    this.setState({ revokeMessageOpen: true })
  }
  handleMessageClose() {
    this.setState({
      revokeMessageOpen: false,
      revokeDialogOpen: false,
    })
    this.props.resetRevokeMessage()
  }

  toggleWebhook = (
    event,
    smartsheetId,
    sheetName,
    webhookId,
    user,
    rowIndex,
  ) => {
    handleFireflySendClickEvent(
      'CLICK',
      'Pin Generation',
      'Pin Generation - Toggle Webhook',
      user,
    )
    if (this.state.rowLoading.includes(rowIndex) !== true) {
      const allLoadingRows = this.state.rowLoading.concat(rowIndex)
      if (event.target.value === 'false') {
        if (webhookId !== 'N/A') {
          this.props.deletePinGenerationHook(webhookId)
        }
        this.setState({ pinsMessage: '' })
        this.handleOpen()
        this.props.postPins(smartsheetId)
        const userName = user.email
          .substring(0, user.email.indexOf('@'))
          .replace('.', ' ')
        const newWebhookData = {
          callbackUrl: `${apiConfig.api.rapidUrl}/callback_generate_pins`,
          name: 'Pins-' + sheetName + '|' + userName,
          smartsheetId: smartsheetId,
          enabled: true,
          webhookType: 'pins',
        }
        this.setState({
          newWebhookData: newWebhookData,
          rowLoading: allLoadingRows,
        })
      } else {
        this.setState({ rowLoading: allLoadingRows })
        this.props.deletePinGenerationHook(webhookId)
      }
    }
  }

  revokePinDialogData = (event, email, locations, user) => {
    handleFireflySendClickEvent(
      'CLICK',
      'Pin Generation',
      'Pin Generation - Revoke',
      user,
    )
    event.preventDefault()
    const revokePinData = {
      data: [
        {
          email: email,
          locations: locations.split(',').map((x) => +x),
        },
      ],
    }
    this.setState({ revokeMessageOpen: true })
    this.props.revokePin(revokePinData)
    this.dialogBox.current.resetForm()
  }
  formatStatus = (input) => {
    let formattedStatus
    if (input === 'ENABLED') {
      formattedStatus = 'Enabled'
    } else if (input === 'NEW_NOT_VERIFIED') {
      formattedStatus = 'Not Verified'
    } else if (input === 'DISABLED_BY_OWNER') {
      formattedStatus = 'Disabled By Owner'
    } else if (input === 'DISABLED_VERIFICATION_FAILED') {
      formattedStatus = 'Verification Failed'
    } else if (input === 'DISABLED_SCOPE_INACCESSIBLE') {
      formattedStatus = 'Smartsheet Scope Not Accessible'
    } else {
      formattedStatus = 'Automate PIN Generation'
    }
    return formattedStatus
  }

  render() {
    let pinSheets = []
    const pinColumns = [
      {
        accessorKey: 'sheetName',
        header: 'Sheet Name',
        size: 400,
        Cell: ({ cell, row }) => {
          const value = cell.getValue()
          const link = row.original.permalink
          return (
            <a href={link} target="_blank" rel="noopener noreferrer">
              {value}
            </a>
          )
        },
      },
      {
        accessorKey: 'webhookId',
        header: 'Webhook Id',
      },
      {
        accessorKey: 'owner',
        header: 'Owner',
      },
      {
        accessorKey: 'webhookEnabled',
        header: 'Disabled/Enabled',
        Cell: ({ cell, row }) => (
          <FormGroup>
            <FormControlLabel
              control={
                <Tooltip title={this.formatStatus(row.original.webhookStatus)}>
                  <Switch
                    color={'primary'}
                    checked={cell.getValue()}
                    value={cell.getValue()}
                    onChange={(event) =>
                      this.toggleWebhook(
                        event,
                        row.original.sheetId,
                        row.original.sheetName,
                        row.original.webhookId,
                        this.props.userInfo,
                        row.index,
                      )
                    }
                  />
                </Tooltip>
              }
            />
          </FormGroup>
        ),
      },
      {
        accessorKey: 'webhookStatus',
        header: 'Status',
        size: 120,
        enableHiding: true,
      },
      {
        accessorKey: 'permalink',
        header: 'Smartsheet Link',
        enableHiding: true,
      },
      {
        accessorKey: 'sheetId',
        header: 'Smartsheet Id',
        enableHiding: true,
      },
    ]

    const defaultColumns = ['sheetName', 'webhookId', 'owner', 'webhookEnabled']

    pinSheets = (
      <MrtReusableTable
        pageTitle="PIN Generation"
        columns={pinColumns}
        defaultColumns={defaultColumns}
        rowData={this.props.pinsList}
        loading={this.state.loading}
        loadingMessage="Loading PIN Sheets..."
        pageSize={[10, 20, 50]}
        menuButtons={
          <div>
            <Tooltip title="Help">
              <IconButton
                onClick={this.handlePinHelpOpen}
                sx={{
                  color: ziptieColors.primary.contrastText,
                  marginLeft: '-4px',
                }}
              >
                <HelpOutlineIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Revoke PINs">
              <IconButton
                onClick={this.handleRevokeOpen}
                sx={{
                  color: ziptieColors.primary.contrastText,
                  marginLeft: '-4px',
                }}
              >
                <RemoveIcon />
              </IconButton>
            </Tooltip>
          </div>
        }
      />
    )

    const pinsPanel = <div>{pinSheets}</div>

    return (
      <div>
        <HeaderTitle title="PIN Generation" />
        <Grid
          container
          direction="row"
          spacing={8}
          justifyContent="space-evenly"
          alignItems="center"
        >
          <Grid item size={{ xs: 12 }}>
            <CreationSuccessModal
              open={this.state.dialogOpen}
              handleClose={this.handleClose}
              pinsMessage={this.state.pinsMessage}
            />
            <PinHelpDialog
              open={this.state.pinHelpOpen}
              handlePinHelpClose={this.handlePinHelpClose}
            />
            <RevokePinDialog
              open={this.state.revokeDialogOpen}
              helpOpen={this.state.revokePinHelpOpen}
              handleRevokeClose={this.handleRevokeClose}
              revokePinDialogData={this.revokePinDialogData}
              user={this.props.userInfo}
              ref={this.dialogBox}
              messageOpen={this.state.revokeMessageOpen}
              revokeMessage={this.state.revokeMessage}
              handleMessageOpen={this.handleMessageOpen}
              handleMessageClose={this.handleMessageClose}
              handleRevokePinHelpOpen={this.handleRevokePinHelpOpen}
              handleRevokePinHelpClose={this.handleRevokePinHelpClose}
            />
            {pinsPanel}
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    result: state.pinGeneration.result,
    pinsList: state.pinGeneration.pinsList,
    userInfo: state.auth.userInfo,
    pinsMessage: state.pinGeneration.pinsMessage,
    revokeMessage: state.pinGeneration.revokeMessage,
  }
}

const mapDispatchToProps = {
  postPins,
  getPinsWithHooks,
  createPinGenerationHook,
  deletePinGenerationHook,
  revokePin,
  resetRevokeMessage,
}

export default connect(mapStateToProps, mapDispatchToProps)(PinGeneration)
